const categories = [
  {
    "name": "people",
    "title": "人物",
    "type": "1",
    "prefix": "https://static.max-c.com/static/heybox-chat/twemoji/",
    "size": "small"
  },
  {
    "name": "natural",
    "title": "自然",
    "type": "2",
    "prefix": "https://static.max-c.com/static/heybox-chat/twemoji/",
    "size": "small"
  },
  {
    "name": "food",
    "title": "食物",
    "type": "3",
    "prefix": "https://static.max-c.com/static/heybox-chat/twemoji/",
    "size": "small"
  },
  {
    "name": "activity",
    "title": "运动",
    "type": "4",
    "prefix": "https://static.max-c.com/static/heybox-chat/twemoji/",
    "size": "small"
  },
  {
    "name": "travel",
    "title": "旅行",
    "type": "5",
    "prefix": "https://static.max-c.com/static/heybox-chat/twemoji/",
    "size": "small"
  },
  {
    "name": "objects",
    "title": "物体",
    "type": "6",
    "prefix": "https://static.max-c.com/static/heybox-chat/twemoji/",
    "size": "small"
  },
  {
    "name": "symbol",
    "title": "符号",
    "type": "7",
    "prefix": "https://static.max-c.com/static/heybox-chat/twemoji/",
    "size": "small"
  },
  {
    "name": "flag",
    "title": "旗帜",
    "type": "8",
    "prefix": "https://static.max-c.com/static/heybox-chat/twemoji/",
    "size": "small"
  }
]

export default categories